import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

export default () => (
  <Breadcrumb style={{ margin: '16px 0' }}>
    <Breadcrumb.Item>
      <Link to="/">Home</Link>
    </Breadcrumb.Item>
    <Breadcrumb.Item>Tool Box Talk Signing</Breadcrumb.Item>
  </Breadcrumb>
);
